import { combineReducers, configureStore } from '@reduxjs/toolkit'
import { persistStore, persistReducer } from 'redux-persist'
import authReducer from './auth-reducer'
import createWebStorage from 'redux-persist/lib/storage/createWebStorage'
import serviceRequestsReducer from './service-requests-reducer'
import paySmallSmallReducer from './pay-small-small-reducer'
import devicesReducer from './devices-reducer'
import walletsReducer from './wallets-reducer'
import transactionsReducer from './transactions-reducer'
import appReducer from './app-reducer'

const createNoopStorage = () => {
    return {
        getItem(_key: string) {
            return Promise.resolve(null)
        },
        setItem(_key: string, value: any) {
            return Promise.resolve(value)
        },
        removeItem(_key: string) {
            return Promise.resolve()
        },
    }
}

const storage = typeof window !== 'undefined' ? createWebStorage('local') : createNoopStorage()

const persistStoreConfig = (key: string) => ({
    key: key,
    storage,
})

const rootReducer = combineReducers({
    app: appReducer,
    auth: persistReducer(persistStoreConfig('auth'), authReducer),
    serviceRequest: persistReducer(persistStoreConfig('serviceRequestPage'), serviceRequestsReducer),
    meters: persistReducer(persistStoreConfig('devices'), devicesReducer),
    paySmallSmall: persistReducer(persistStoreConfig('paySmallSmallReducer'), paySmallSmallReducer),
    wallets: persistReducer(persistStoreConfig('walletsReducer'), walletsReducer),
    transactions: persistReducer(persistStoreConfig('transactionsReduc'), transactionsReducer),
})

export const store = configureStore({
    reducer: rootReducer,
    devTools: process.env.NODE_ENV !== 'production',
})

export const persistor = persistStore(store)
export type RootState = ReturnType<typeof store.getState>
export type AppDispatch = typeof store.dispatch
